/**
 * Colour values
 * @enum {string}
 */
export enum Colour {
  Black = 'black',
  Blue = 'blue',
  Current = 'current',
  DarkBlue = 'dark-blue',
  Green = 'green',
  Jet = 'jet',
  LightBlue = 'light-blue',
  PastelBlue = 'pastel-blue',
  PastelGreen = 'pastel-green',
  PastelPurple = 'pastel-purple',
  PastelRed = 'pastel-red',
  Purple = 'purple',
  Red = 'red',
  Transparent = 'transparent',
  Silver = 'silver',
  White = 'white',
  DarkGrey = 'dark-grey',
}

/**
 * Determine the best colour for featuring content from the the value passed in
 * @param {Colour} colour The background colour
 * @returns {Colour} The matching/recommended feature colour
 */
export const getFeatureColourFromBackground = (colour: Colour | unknown) => {
  switch (colour) {
    case Colour.PastelBlue:
    case Colour.PastelGreen:
    case Colour.PastelPurple:
    case Colour.PastelRed:
    case Colour.Silver:
    case Colour.White:
      return Colour.Blue;

    default:
      return getForegroundColourFromBackground(colour);
  }
};

/**
 * Determine the best foreground colour for the value passed in
 * @param {Colour} colour The background colour
 * @returns {Colour} The matching/recommended foreground colour
 */
export const getForegroundColourFromBackground = (colour: Colour | unknown) => {
  switch (colour) {
    case Colour.Black:
    case Colour.Blue:
    case Colour.DarkBlue:
    case Colour.Green:
    case Colour.Jet:
    case Colour.LightBlue:
    case Colour.Purple:
    case Colour.Red:
      return Colour.White;

    default:
      return Colour.DarkGrey;
  }
};
